import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import { api } from '../../../services/api';
import Layout from '../../../components/Admin/Layout';

import "./styles.scss";

type User = {
  id: string;
  name: string;
  email: string;
  role: string;
  partner: [
    {
      id: string;
      name: string;
      email: string;
      role: string;
      partner: string;
    }
  ];
};

const EditarUsuario = () => {
  const [searchTerm, setSearchId] = useState("");
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    role: "",
  });
  const [partners, setPartners] = useState([]);
  
  const [mensagem, setMensagem] = useState("");

  const camposEditaveis = [
    { label: "Nome", name: "name", type: "text" },
    { label: "Email", name: "email", type: "email" },
    { label: "Perfil", name: "role", type: "select", options: ["USER", "ADMIN", "PARTNER_CONSULTANT", "PARTNER_MANAGER"] },
    { label: "Parceiro", name: "partner", type: "select", options: partners as { id: string; name: string }[] },
  ];

  const handleSearch = async () => {
    try {
      const { 
        data: {
          found: { users }
        } 
      } = await api.get(`/users`, {
        params: { 
          cpf: searchTerm,
          page: 1,
          limit: 10,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("@TNB:token")?.replace(/"/g, "") || ""}`
        },
      });


      if(users.length > 0) {
        users.forEach((user: User) => {
          setFormData({
            id: user.id,
            name: user.name,
            email: user.email,
            role: user.role,
          });
          setMensagem("Usuário carregado com sucesso.");
        })
        try {
          const { data } = await api.get(`/partners`);
          setPartners(data?.partners);

          setMensagem("Parceiros carregados com sucesso.");
        } catch (error) {
          setMensagem("Erro ao carregar o parceiro.");
        }
      }
    } catch (error) {
      setMensagem("Erro ao buscar usuário.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`/users/${formData.id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("@TNB:token")?.replace(/"/g, "") || ""}`,
        },
      });
      setMensagem("Usuário atualizado com sucesso!");
    } catch (error) {
      setMensagem("Erro ao atualizar usuário.");
    }
  };

  return (
    <Layout pageBreadcrumb="Gerenciamento de Usuários" pageTitle="Gerenciamento de Usuários">
      <Container>
        <h2 className="mx-4">Editar Usuário</h2>
        {mensagem && <Alert variant="info">{mensagem}</Alert>}

        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm={2}>Buscar por CPF</Form.Label>
          <Col sm={8}>
            <Form.Control
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchId(e.target.value)}
            />
          </Col>
          <Col sm={2}>
            <Button onClick={handleSearch}>Buscar</Button>
          </Col>
        </Form.Group>

        {formData && (
          <Form onSubmit={handleSubmit}>
            {camposEditaveis?.map((campo) => (
              <Form.Group as={Row} key={campo.name}>
                <Form.Label column sm={2}>{campo.label}</Form.Label>
                <Col sm={10} gap={2}>
                  {campo.type === "select" ? (
                    <Form.Control
                      as="select"
                      name={campo.name}
                      value={formData[campo.name]}
                      onChange={handleChange}
                    >
                      <option value="">Selecione</option>
                      {(campo?.options ?? []).map((option) =>
                        typeof option === "string" ? (
                          <option key={option} value={option}>{option}</option>
                        ) : (
                          <option key={option?.id} value={option?.id}>{option?.name}</option>
                        )
                      )}
                    {/* TODO: Enviar os dados do id de partnerUuid para a requisição de users */}
                    </Form.Control>
                  ) : (
                    <Form.Control
                      type={campo.type}
                      name={campo.name}
                      value={formData[campo.name]}
                      onChange={handleChange}
                    />
                  )}
                </Col>
              </Form.Group>
            ))}
            <Button variant="primary" className="btn-submit" type="submit">Salvar Alterações</Button>
          </Form>
        )}
      </Container>
    </Layout>
  );
};

export default EditarUsuario;
